import { Box, ColorOptions, convertHexToRGBA, Image, Spacer, Text } from '@jfs/ui-new'
import { Platform } from 'react-native'
import { SvgImage } from '../../comps/SvgImage'
import { Colors } from '../../util/util'

export const VoiceBoxList = ({ data, index, onProceed }: any) => {
  return (
    <Box
      underlayColor={'TRANSPARENT'}
      marginVertical={15}
      width={'100%'}
      flexDirection="row"
      align="center"
      testID={'voicebox-' + index + 1}
      onPress={() => onProceed({ ...data, deviceName: `Voicebox ${index + 1}`, index })}>
      <Box
        width={75}
        height={75}
        backgroundColor={convertHexToRGBA(Colors.PRIMARY, 10) as ColorOptions}
        borderRadius={15}
        align="center"
        justify="center">
        {/* {renderImage()} */}
        <Image
          source={Platform.OS === 'ios' ? require('../../assets/images/qr_scan.png') : 'qrscan'}
          resizeMode="contain"
          width={65}
          height={65}
        />
        {/* <Image source={require('../../assets/images/qr_invalid.png')} width={70} height={70} /> */}
        {/* <IconNew id="SCAN_QR" size={45} /> */}
      </Box>
      <Spacer size={20} direction="horizontal" />
      <Box>
        <Text fontFamily="JioType-Bold" lineHeight={24} fontSize={18} color={Colors.BLACK_14 as ColorOptions}>
          Voicebox {index + 1}
        </Text>
        <Spacer size={2} direction="vertical" />
        <Text
          testID="voice-s-no"
          fontFamily="JioType-Medium"
          lineHeight={20}
          fontSize={14}
          color={Colors.BLACK_14 as ColorOptions}>
          Serial No. {data?.details?.dsn}
        </Text>
        {data.isPendingBTPairRequest && (
          <>
            <Spacer size={4} direction="vertical" />
            <Box flexDirection={'row'} alignItems={'center'}>
              <SvgImage imageName="BluetoothSymbol" width={16} height={16} color={Colors.PRIMARY} />
              <Spacer size={4} direction="horizontal" />
              <Text fontFamily="JioType-Bold" color="PRIMARY" fontSize={12}>
                New Request
              </Text>
            </Box>
          </>
        )}
      </Box>
    </Box>
  )
}
